/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IProfile {
        action?: string;
        profileParams: IProfileParam[];
    }

    export interface IProfileParam {
        paramName: string;
        paramDescription: string;
        paramValue: string;
        paramValueDescription: string;
        paramOptions: IParamOption[];
    }

    export interface IParamOption {
        possibleValue: any; // tslint:disable-line
        valueDesc: string;
    }

    export class Profile implements IProfile {
        public action: string;
        public profileParams: IProfileParam[];

        public static Empty(): Profile {
            return new Profile();
        }

        constructor() {
            // empty constructor
            this.action = 'update_profile'; // default value
            this.profileParams = [];
        }
    }
}